// extracted by mini-css-extract-plugin
module.exports = {"CategorySettings":"category-settings_CategorySettings__28Xg6"};